import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

type Which = 'to' | 'from';
@Component({
  selector: 'custom-form-slider',
  templateUrl: './custom-form-slider.component.html',
  styleUrls: ['./custom-form-slider.component.css'],
})
export class CustomFormSliderComponent extends FieldType implements OnInit {
  minPercentageGap = 10;
  fromTooltipPosition: string;
  toTooltipPosition: string;
  fromTooltipValue: number;
  toTooltipValue: number;
  currentFromPercent: number;
  currentToPercent: number;
  minValue: number;
  maxValue: number;
  sliderWidth: number;

  ngOnInit(): void {
    this.minValue = this.props.min;
    this.maxValue = this.props.max;
    this.fromTooltipValue = this.props.from;
    this.toTooltipValue = this.props.to;
    this.updateSlider();
  }

  onSliderChange(event: any) {
    this.currentFromPercent = event.from_percent;
    this.currentToPercent = event.to_percent;
    this.fromTooltipValue = event.from;
    this.toTooltipValue = event.to;
    this.updateCustomTooltip();

    const newValue = { from: this.fromTooltipValue, to: this.toTooltipValue };
    this.formControl.setValue(newValue);
  }

  updateCustomTooltip(): void {
    const range = this.maxValue - this.minValue;
    let percentageFrom = ((this.fromTooltipValue - this.minValue) / range) * 95;
    let percentageTo = ((this.toTooltipValue - this.minValue) / range) * 95;

    let gap = percentageTo - percentageFrom;

    // Adjust if tooltips percentages overlap
    if (gap < this.minPercentageGap) {
      const overlapAdjustment = (this.minPercentageGap - gap) / 2;
      percentageFrom -= overlapAdjustment;
      percentageTo += overlapAdjustment;
    }

    this.fromTooltipPosition = `${percentageFrom}%`;
    this.toTooltipPosition = `${percentageTo}%`;
  }

  updateSlider(event?: any, which?: Which) {
    let newValue = event?.target.value;
    if (event && which) {
      {
        newValue = newValue.replaceAll('k', '000');

        newValue = newValue.replaceAll('m', '000000');

        newValue = newValue.replaceAll('b', '000000000');
      }
      newValue = Number(newValue);

      if (newValue < this.minValue || newValue > this.maxValue) return;

      let fromValue = which === 'from' ? newValue : this.fromTooltipValue;
      let toValue = which === 'to' ? newValue : this.toTooltipValue;

      // swap the values if from > to or vice versa
      if (fromValue > toValue) {
        [fromValue, toValue] = [toValue, fromValue];
      }

      this.fromTooltipValue = fromValue;
      this.toTooltipValue = toValue;
    }

    this.currentFromPercent =
      ((this.fromTooltipValue - this.minValue) /
        (this.maxValue - this.minValue)) *
      100;
    this.currentToPercent =
      ((this.toTooltipValue - this.minValue) /
        (this.maxValue - this.minValue)) *
      100;

    this.formControl.setValue({
      from: this.fromTooltipValue,
      to: this.toTooltipValue,
    });

    this.updateCustomTooltip();
  }
}
